import { Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";

const ExtractReport = ({
  text = "Extract report",
  styles,
  downloadFunction,
  isLoading = false
}) => {
  // Get user permissions from local storage
  const [userAccess, _userAccess] = useState(
    JSON.parse(localStorage.getItem("permissions"))
  );

  // Check if user has permission to extract reports
  const extractReportAccess = userAccess?.find(
    (o) => o.slug === "extract_reports"
  );

  const hasReadPermission = extractReportAccess?.permissions?.some(
    (o) => o.slug === "read"
  );

  if (!hasReadPermission) return null; // Hide button if the user lacks access

  return (
    <StyledButton onClick={downloadFunction} className={styles} disabled={isLoading}>
      {!isLoading ? text : <CircularProgress size={24} style={{ position: 'absolute', color: "#000" }} />}
    </StyledButton>
  );
};

export default ExtractReport;

const StyledButton = styled(Button)`
  min-width: 140px !important;
`
